import React from 'react';

export interface RadarDatum { label: string; value: number; }

// Schoon SVG-spinnenweb: assen per categorie, score-vlak in de thema-accentkleur.
export const RadarChart: React.FC<{ data: RadarDatum[]; accent: string; max?: number }> = ({ data, accent, max = 5 }) => {
  const N = data.length;
  if (N < 3) return null;

  const W = 460, H = 360, cx = W / 2, cy = H / 2, R = 118;
  const angle = (i: number) => -Math.PI / 2 + (i * 2 * Math.PI) / N;
  const pt = (i: number, r: number): [number, number] => [cx + Math.cos(angle(i)) * r, cy + Math.sin(angle(i)) * r];
  const poly = (r: number) => data.map((_, i) => pt(i, r).join(',')).join(' ');
  const valuePoly = data.map((d, i) => pt(i, R * (Math.max(0, Math.min(max, d.value)) / max)).join(',')).join(' ');

  // Label in maximaal twee gebalanceerde regels.
  const wrap = (s: string): string[] => {
    if (s.length <= 12) return [s];
    const words = s.split(' ');
    if (words.length === 1) return [s];
    let best = 1, diff = Infinity;
    for (let k = 1; k < words.length; k++) {
      const a = words.slice(0, k).join(' ').length, b = words.slice(k).join(' ').length;
      if (Math.abs(a - b) < diff) { diff = Math.abs(a - b); best = k; }
    }
    return [words.slice(0, best).join(' '), words.slice(best).join(' ')];
  };

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" role="img" aria-label="Spinnenweb met je score per categorie" style={{ maxWidth: 460, margin: '0 auto', display: 'block' }}>
      {[1, 2, 3, 4, 5].filter((r) => r <= max).map((r) => (
        <polygon key={r} points={poly(R * (r / max))} fill="none" stroke="#E7E2DB" strokeWidth={1} />
      ))}
      {data.map((_, i) => { const [x, y] = pt(i, R); return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="#EFEAE3" strokeWidth={1} />; })}
      <g className="radar-in">
        <polygon points={valuePoly} fill={accent} fillOpacity={0.16} stroke={accent} strokeWidth={2.5} strokeLinejoin="round" />
        {data.map((d, i) => { const [x, y] = pt(i, R * (Math.max(0, Math.min(max, d.value)) / max)); return <circle key={i} cx={x} cy={y} r={4} fill={accent} />; })}
      </g>
      {data.map((d, i) => {
        const [lx, ly] = pt(i, R + 16);
        const c = Math.cos(angle(i));
        const anchor = Math.abs(c) < 0.3 ? 'middle' : c > 0 ? 'start' : 'end';
        const lines = wrap(d.label);
        return (
          <text key={i} x={lx} y={ly - (lines.length - 1) * 7} textAnchor={anchor as 'start' | 'middle' | 'end'} fontSize={12} fontWeight={600} fill="#514838" fontFamily="'IBM Plex Sans', sans-serif">
            {lines.map((ln, k) => <tspan key={k} x={lx} dy={k === 0 ? 0 : 14}>{ln}</tspan>)}
          </text>
        );
      })}
    </svg>
  );
};
